import React, {useState} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './AggregateStatusPopup.module.css';
import {makeStyles} from '@material-ui/core/styles';
import {Popover} from '@material-ui/core';

const AggregateStatusPopup = ({agsn}) => {
  const fields = [
    {name: 'Reason', field: 'reason'},
    {name: 'Agency', field: 'agency'},
    {name: 'Comment', field: 'comment'},
  ];

  const [isTextOverflowPopupOpen, setIsTextOverflowPopupOpen] = useState(false);
  const [popoverVal, setPopoverVal] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleTextOverFlowPopOverOpen = (event, value) => {
    if (event.currentTarget.scrollWidth > event.currentTarget.clientWidth) {
      setPopoverVal(value);
      setIsTextOverflowPopupOpen(true);
      setAnchorEl(event.currentTarget);
    }
  };

  const handleTextOverFlowPopOverClose = () => {
    setIsTextOverflowPopupOpen(false);
    setAnchorEl(null);
  };
  const closePopup = () => setIsTextOverflowPopupOpen(false);
  const useTextOverflowPopoverStyles = makeStyles(theme => ({
    popover: {
      pointerEvents: 'none',
    },
    paper: {
      padding: theme.spacing(1),
      color: 'white',
      backgroundColor: 'grey',
      fontSize: '12px', //TODO: keep same as popover
    },
  }));

  const overflowPopoverClasses = useTextOverflowPopoverStyles();
  return (
    <div className={styles.AggregateBox}>
      <div className={styles.inner}>
        <div>
          <span className={styles.title}>
            <strong>LineOut</strong>
          </span>
        </div>

        {fields.map(({name, field}) => (
          <div className={clsx(styles.row)}>
            <span> {name}</span>
            <strong
              onMouseEnter={e => handleTextOverFlowPopOverOpen(e, agsn[field])}
              onMouseLeave={handleTextOverFlowPopOverClose}
            >
              {agsn[field]}
            </strong>
          </div>
        ))}
      </div>

      <Popover
        open={isTextOverflowPopupOpen}
        anchorEl={anchorEl}
        onClose={closePopup}
        className={overflowPopoverClasses.popover}
        classes={{
          paper: overflowPopoverClasses.paper,
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {popoverVal}
      </Popover>
    </div>
  );
};

AggregateStatusPopup.propTypes = {
  agsn: PropTypes.shape({
    reason: PropTypes.string.isRequired,
    agency: PropTypes.string.isRequired,
    comment: PropTypes.string,
  }),
};

export default AggregateStatusPopup;
